export const DEFAULT_EVENT_PARAMS = {
	limit: 8,
	onlyBusinessAuthors: false,
}
